<template>
    <div class="ckp-email-builder ckp-form">
        <div class="container">
            <div class="row padding-top-50 ">
                <div class="col-md-7 margin-bottom-40">
                    <div class="row">
                        <div class="col-md-12">
                            <h1>{{translations.EmailBuilderTitle}}</h1>
                            <p class="text-18">{{translations.EmailBuilderDescription}}</p>
                            <p>{{translations.SelectOptionLabel}}</p>
                            <div class="radioButtonSet">
                                <div class="radioButtonSet__button">
                                    <input v-model="sendOptionsEmail" type="radio" id="sendOptionsEmailFalse"
                                        name="sendOptionsEmail" value="false" class="radioButton" @click="softReset()" />
                                    <label for="sendOptionsEmailFalse">{{translations.OnlineLinkText}}</label>
                                </div>
                                <div class="radioButtonSet__button">
                                    <input v-model="sendOptionsEmail" type="radio" id="sendOptionsEmailTrue"
                                        name="sendOptionsEmail" value="true" class="radioButton" @click="softReset()" />
                                    <label for="sendOptionsEmailTrue">{{translations.EmailLinkText}}</label>
                                </div>
                            </div>
                            <template v-if="sendOptionsEmail === 'true'">
                                <h4>{{translations.AddRecipientText}}</h4>
                                <hr>
                                <p>{{translations.AddRecipientDescription}}</p>
                                <div class="row">
                                    <div class="col-md-9">
                                        <email-list v-bind:emailRecipients="emailRecipients"
                                            v-bind:sendOptionsEmail="sendOptionsEmail"
                                            v-bind:placeholder="translations.RecipientsEmailAddress"
                                            v-bind:emailrequired="translations.RecipientRequiredErrorMessage"
                                            v-bind:emailInvalid="translations.RecipientEmailInvalidErrorMessage">
                                        </email-list>
                                    </div>
                                </div>
                                <label for="senders-email">{{translations.SenderEmailAddressText}}</label>
                                <p>{{translations.SenderEmailAddressDescription}}</p>
                                <div class="row">
                                    <div class="col-md-9">
                                        <input v-model='$v.emailSender.$model' type="email"
                                            v-bind:placeholder="translations.SendersEmailAddress" />
                                        <div class="field-validation-error"
                                            v-if="$v.emailSender.$dirty && !$v.emailSender.required">{{translations.SenderEmailRequiredErrorMessage}}</div>
                                        <div class="field-validation-error"
                                            v-else-if="$v.emailSender.$dirty && !$v.emailSender.email">{{translations.SenderEmailInvalidErrorMessage}}</div>
                                    </div> 
                                </div>
                            </template>
                            <h4>{{translations.AddContentText}}</h4>
                            <hr>
                            <template v-if="sendOptionsEmail === 'true'">
                                <label for="email-intro">{{translations.EmailIntroLabel}}</label>
                                <p>{{translations.EmailIntroDescription}}
                                </p>
                                <textarea v-model='$v.introduction.$model' id="email-intro" v-bind:placeholder="translations.TypeSummary"
                                    rows="5" maxlength="583"></textarea>
                                <div class="field-validation-error"
                                    v-if="$v.introduction.$dirty && !$v.introduction.required">{{translations.EmailIntroductionRequiredErrorMessage}}</div>
                            </template>
                            <p class="bold-magenta">{{translations.ContentToShare}}</p>
                            <p>{{translations.ContentToDescription}}</p>
                        </div>
                        <div class="col-md-6 margin-bottom-30">
                            <select class="selectpicker" multiple="" name="Sectors" v-bind:title="translations.AllSectors"  v-model="sectors">
                                <option
                                    v-for="sector in sectorList"
                                    v-bind:value="sector.Id"
                                    v-bind:key="sector.Id">
                                    {{sector.Name}}
                                </option>
                            </select></div>
                        <div class="col-md-6 margin-bottom-30">
                            <select class="selectpicker" multiple="" name="topics" v-bind:title="translations.AllLegalAndBusinessTopics" v-model="topics">
                                <option
                                    v-for="topic in topicList"
                                    v-bind:value="topic.Id"
                                    v-bind:key="topic.Id">
                                    {{topic.Topics}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 margin-bottom-30">
                            <select class="selectpicker" multiple="" name="jurisdictions" v-bind:title="translations.AllJurisdictions" v-model="jurisdictions">
                                <option value="" selected disabled>Select Jurisdictions</option>
                                <optgroup v-for="option in jurisdictionList" v-bind:key="option.id" v-bind:label="option.Title">
                                    <option v-for="subOption in option.Jurisdictions" v-bind:key="subOption.SingleLocation" v-bind:value="subOption.SingleLocation">{{subOption.Title}}</option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-md-6 margin-bottom-30">
                            <select class="selectpicker" multiple="" name="category" v-bind:title="translations.AllContentType" v-model="categories">
                                <option
                                    v-for="category in categoryList"
                                    v-bind:value="category.Id"
                                    v-bind:key="category.Id">
                                    {{category.Topics}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <input v-model='fromDate' id='fromDate' type="text" v-bind:placeholder="translations.FromDate" class="dateInput" data-date-format="dd/mm/yyyy" autocomplete="off"/>
                        </div>
                        <div class="col-md-6">
                            <input v-model='toDate' id='toDate' type="text" v-bind:placeholder="translations.ToDate" class="dateInput" data-date-format="dd/mm/yyyy" autocomplete="off"/>
                        </div>
                        <div class="col-md-12">
                            <ArticleSearch 
                                v-bind:addedArticles="addedArticles"
                                v-bind:topics="topics"
                                v-bind:sectors="sectors"
                                v-bind:jurisdictions="jurisdictions"
                                v-bind:categories="categories"
                                v-bind:toDate="toDate"
                                v-bind:fromDate="fromDate"
                                v-bind:placeholder="translations.SearchTermLabel"

                                ></ArticleSearch>
                        </div>
                        <div class="col-sm-6">
                            <div class="reset" v-on:click="reset">{{translations.Reset}}</div>
                        </div>
                        <div class="col-sm-6 text-right">
                            <div class="row">
                                <div class="col-sm-6"><button type="button" class="ll-btn ll-btn--100 ll-btn--grey-dark"
                                        data-dismiss="modal" data-toggle="modal"
                                        data-target="#emailPreviewModal">{{translations.PreviewButtonLabel}}</button></div>
                                <div class="col-sm-6">

                                    <template v-if="sendOptionsEmail === 'false'">
                                        <button type="button" class="ll-btn ll-btn--100"
                                        v-on:click="validateAndSubmit">{{translations.GenerateLinkButtonLabel}}</button>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="ll-btn ll-btn--100"
                                        v-on:click="validateAndSubmit">Email</button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="previewUrl != ''">
                        <div class="row">
                            <div class="col-md-7 col-md-offset-5">
                                <div class="preview-link">
                                     <div>{{previewUrl}}</div>
                                    <input type="text" v-model="previewUrl" id="copyThis" style="opacity: 0; opacity: 0;height: 0;"/>
                                </div> <button type="button" class="ll-btn ll-btn--100" v-on:click="doCopy"
                                 >Copy Link</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-4 col-md-offset-1 margin-bottom-40">
                    <div id="related-content-container" class="related-content-container" v-bind:class="{ 'related-content-container--show': addedArticlesExist }">
						<div class="sortableList">
                    <h3 class="magenta20Bold">Content</h3>
                    <DraggableArticles v-bind:addedArticles="addedArticles"></DraggableArticles>
                </div>
                    </div>
                    </div>
            </div>
        </div>

        <!-- Request Fail -->
        <div class="modal fade" id="failModal" role="complementary"
            aria-labelledby="failModalLabel" aria-describedby="Email Check">
            <div class="modal-dialog emailPublishWarningModal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title pull-right" id="failModalLabel" data-dismiss="modal">Close
                            &nbsp;×</p>
                    </div>
                    <div class="modal-body text-center">
                        <h1>Fail</h1>
                            <div class="fail-message">
                                <p>Something went wrong. An invalid response was received from the server.</p>
                            </div>
                        <button type="button" class="ll-btn" data-dismiss="modal" >Close</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Email Success Modal -->
        <div class="modal fade" id="emailSuccessModal" role="complementary"
            aria-labelledby="emailSuccessModalLabel" aria-describedby="Email Check">
            <div class="modal-dialog emailPublishWarningModal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title pull-right" id="emailSuccessModalLabel" data-dismiss="modal">Close
                            &nbsp;×</p>
                    </div>
                    <div class="modal-body text-center">
                        <h1>Success</h1>
                        <p>Your email was sent.</p>
                        <button type="button" class="ll-btn" data-dismiss="modal" >Close</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Email Publish Warning Modal -->
        <div class="modal fade" id="emailPublishWarningModal" role="complementary"
            aria-labelledby="emailPublishWarningModalLabel" aria-describedby="Email Check">
            <div class="modal-dialog emailPublishWarningModal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title pull-right" id="emailPublishWarningModalLabel" data-dismiss="modal">Close
                            &nbsp;×</p>
                    </div>
                    <div class="modal-body text-center">
                        <h1>Publish Warning</h1>
                        <p>The following users may have already received the content you are about to send them.</p>
                        <template v-if="warnings.length > 0">
                            <div class="text-center">
                                <div class="select-option" v-for="warning in warnings" v-bind:key="warning.id">
                                    <p><span class="magenta">{{warning.email}}</span> received
                                        <strong>{{warning.article}} on {{warning.receivedDate}}</strong>
                                        <template v-if="warning.openedDate != undefined"> and clicked to open it on
                                            <strong>{{warning.openedDate}}</strong>
                                        </template>
                                    </p>
                                     <div class="tiny-border"></div>
                                </div>
                            </div>
                        </template>

                        <button type="button" class="secondaryButton" data-dismiss="modal">Edit</button>
                        <button type="button" class="" data-dismiss="modal"  v-on:click="validateAndSubmitIgnoringWarnings">Submit</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Email Publish Warning Modal -->
        <div class="modal fade" id="errorModal" role="complementary"
            aria-labelledby="errorModalLabel" aria-describedby="Email Check">
            <div class="modal-dialog emailPublishWarningModal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title pull-right" id="errorModal" data-dismiss="modal">Close&nbsp;×</p>
                    </div>
                    <div class="modal-body text-center">
                        <h1>Error</h1>
                        <template v-if="errors.length > 0">
                            <div class="text-center">
                                <div class="select-option" v-for="error in errors" v-bind:key="error.id">
                                    <p>{{error.message}}</p>
                                    <div class="tiny-border"></div>
                                </div>
                            </div>
                        </template>
                        <button type="button" class="" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Email Preview Modal -->
        <div class="modal fade" id="emailPreviewModal" role="complementary" aria-labelledby="emailPreviewModalLabel"
            aria-describedby="Email Check">
            <div class="modal-dialog emailPreviewModal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title pull-right" id="emailPreviewModalLabel" data-dismiss="modal">Close &nbsp;×
                        </p>
                    </div>
                    <div class="modal-body">
                        <template v-if="sendOptionsEmail === 'true'">
                            <div class="text-center">
                                <h1>Email Preview</h1>

                                <div class="previewBox previewBox--email">
                                    <div class="emailPreviewContent">
                                        <img src="/assets/foundation/images/ckp/preview-email-header.png" />
                                        <div class="previewBox__message-content">
                                            <p v-html="introductionPreview"></p>
                                            <hr>
                                            <ArticleList v-bind:addedArticles="addedArticles"
                                                v-bind:introduction="introduction"></ArticleList>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </template>
                        <template v-else-if="sendOptionsEmail === 'false'">
                            <div class="text-center">
                                <h1>Link Preview</h1>

                                <div class="previewBox previewBox--link">
                                    <img src="/assets/images/ckp/preview-link-header.png" />
                                    <div class="linkPreviewContent">

                                        <ArticleList v-bind:addedArticles="addedArticles"
                                            v-bind:introduction="introduction"></ArticleList>
                                        <img src="/assets/images/ckp/preview-link-footer.png" />
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="text-right">
                            <button type="button" class="" data-dismiss="modal">close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { requiredIf, email, between } from 'vuelidate/lib/validators';
    import EmailList from '../../components/CkpEmailBuilder/EmailList.vue';
    import ArticleSearch from '../../components/CkpEmailBuilder/ArticleSearch.vue';
    import DraggableArticles from '../../components/CkpEmailBuilder/DraggableArticles.vue';
    import ArticleList from '../../components/CkpEmailBuilder/ArticleList.vue';
    import axios from 'axios';
    import shortid from 'shortid';

    export default {
        name: 'app',
        components: {
            EmailList,
            ArticleSearch,
            DraggableArticles,
            ArticleList
        },
        props: {
            modelId: {
                type: String,
                default: 'unassigned'
            }
        },
        data() {
            return {
                baseUrl: "/Assets/data/",
                localUiTestingUrl: "https://neu-ckp-uat-sc-xp-single.azurewebsites.net",
                previewUrl: '',
                state: {
                    submitting: false,
                    loading: false
                },
                sendOptionsEmail: 'false',
                emailRecipients: [],
                emailSender: '',
                introduction: '',
                addedArticles: {
                    articles: []
                },
                sectors: [],
                topics: [],
                jurisdictions: [],
                categories: [],     
                fromDate: '',
                toDate: '',
                adminRef: '',
                warnings: [],
                errors: [],
                ignoreWarnings: false,
                topicList: [],
                sectorList: [],
                jurisdictionList: [],
                categoryList: [],
                translations: []
            }
        },
        validations: {
            emailSender: {
                required: requiredIf(function () {
                    if (this.sendOptionsEmail == "true") {
                        return true;
                    }
                    return false;
                }),
                email
            },
            introduction: {
                required: requiredIf(function () {
                    if (this.sendOptionsEmail == "true") {
                        return true;
                    }
                    return false;
                })
            },
            introductionChars: {
                between: between(0, 583),
            }
            // ,
            // addedArticles: {
            //     required
            // }
        },
        
        mounted() {

            var self = this;
            var $ = window.$;

            this.generateAdminRef();
            this.getTaxonomyData();
            this.getTranslationsData();

            $('body').on('hide.bs.modal', function () {       
                $('body').removeClass('modal-open');
            });



            $('#fromDate').datepicker({ format: 'dd/mm/yyyy' }).on("changeDate", function () {
                self.fromDate = $(this).val();
            });
             $('#toDate').datepicker({ format: 'dd/mm/yyyy' }).on("changeDate", function () {
                self.toDate = $(this).val();
            });

            var relatedContentContainer = $('#related-content-container');
            var $window = $(window);
            $window.scroll(function() {
                if ($window.width() > 991) {
                    relatedContentContainer.css('top', $(window).scrollTop());
                }
            });

            this.init();
        },

        methods: {
            
            init() {
                //let dataUrl =  this.baseUrl + 'get-article-by-id.json';
                let dataUrl = "/webapi/ckp/contentsharing/getarticlebyid";

                if (document.location.host.includes("localhost")) {
                    dataUrl = this.localUiTestingUrl + dataUrl;
                }

                dataUrl = dataUrl + "?id=" + this.$props.modelId;

                axios.get(dataUrl).then(response => {
                    if (response.data.success) {
                        this.addedArticles.articles = response.data.results;
                    }
                });
            },

            reset() {
                this.sendOptionsEmail = 'false',
                this.emailRecipients = [],
                this.emailSender = '',
                this.introduction = '',
                this.addedArticles.articles = [],
                this.sectors = [],
                this.topics = [],
                this.jurisdictions = [],
                this.categories = [],
                this.fromDate = '',
                this.toDate = '',
                this.warnings = [],
                this.errors = [],
                this.ignoreWarnings = false,
                this.previewUrl = '';

                this.generateAdminRef();
            },

            generateAdminRef() {
                this.adminRef = shortid.generate();
            },

            softReset() {
                this.previewUrl = '';
            },

            getTaxonomyData(){
                // let dataUrl =  this.baseUrl + 'article-taxonomy.json';
                let dataUrl = '/webapi/ckp/contentsharing/gettaxonomylists';

                if (document.location.host.includes("localhost")) {
                    dataUrl = this.localUiTestingUrl + dataUrl;
                }

                axios.get(dataUrl).then(response => {
                    this.sectorList = response.data.Sectors;
                    this.topicList = response.data.Topics;
                    this.jurisdictionList = response.data.Jurisdictions;
                    this.categoryList = response.data.Categories;
                });
            },

             getTranslationsData(){
               
                let dataUrl = '/webapi/ckp/contentsharing/gettexttranslations';

                if (document.location.host.includes("localhost")) {
                    dataUrl = this.localUiTestingUrl + dataUrl;
                }

                axios.get(dataUrl).then(response => {
                    this.translations = response.data;
                });
            },

            doCopy: function (e) {
                var $ = window.$;
                let selectEl = $(e.target).prev().children('input')[0];
                selectEl.select();
                document.execCommand("copy");
            },
           
            validateAndSubmitIgnoringWarnings(e) {
                this.ignoreWarnings = true;
                this.validateAndSubmit(e);
            },

            validateAndSubmit(e) { 
                e.preventDefault();
                var $ = window.$;
                var self = this;

                if (this.state.submitting) {
                    //  console.log('submitting'); 
                    return;
                }

                this.$v.$touch();

                if (this.$v.$invalid) {
                    // console.log('invalid', this.$v);
                    return;
                }
                
                // if !valid show error and return
                self.state.submitting = true;
                
                let postData;
                let dataUrl;

                if (self.sendOptionsEmail === 'true') {
                    postData = {
                        emailRecipients: this.emailRecipients,
                        emailSender: this.emailSender,
                        introduction: this.introduction,
                        addedArticles: this.addedArticles.articles,
                        adminRef: this.adminRef,
                        ignoreWarnings: this.ignoreWarnings
                    };

                    dataUrl =  '/webapi/ckp/contentsharing/createandsendemails' 

                    if (document.location.host.includes("localhost")) {
                        dataUrl = this.localUiTestingUrl + dataUrl;
                    }

                    // dataUrl =  '/Assets/data/createEmail-error.json';
                    // dataUrl =  '/Assets/data/createEmail-success.json';
                    // dataUrl =  '/Assets/data/createEmail-warning.json';
                } else {
                    console.log("not here,", this.sendOptionsEmail);
                    postData = {
                        addedArticles: this.addedArticles.articles,
                        adminRef: this.adminRef
                    };

                    dataUrl =  '/webapi/ckp/contentsharing/createpage';

                    if (document.location.host.includes("localhost")) {
                        dataUrl = this.localUiTestingUrl + dataUrl;
                    }

                    // dataUrl =  '/Assets/data/createPage-success.json' ;
                }

                // console.log('postData', postData);

                const options = {
                    // Post for real api
                    method: 'POST', // method: 'GET',
                    headers: { 'content-type': 'application/json' },
                    data: JSON.stringify(postData),
                    url: dataUrl                  
                }

                axios(options)
                .then(response => {
                    console.log('response', response);

                    // show message
                      if (response.data.success) {
                           if (self.sendOptionsEmail === 'true') { 
                                $('#emailSuccessModal').modal();
                            } else {
                                self.previewUrl = response.data.url;
                            }
                      } else {                     
                            if (response.data.warnings) {
                                self.warnings = response.data.warnings;
                                $('#emailPublishWarningModal').modal();
                            } 
                            else if (response.data.errors) {
                                self.errors = response.data.errors;
                                $('#errorModal').modal();
                            }                 
                        }                      
                    // self.data.id = response.id; if (self.sendOptionsEmail)  
                })
                .catch(function (error) {
                    console.log(error);
                    
                    $('#failModal').modal();

                    // self.warnings = "An Error Occured";
                    //  $('#emailPublishWarningModal').modal();
                    //  self.data.id = response.id;
                })
                .then(function() {
                    self.generateAdminRef();
                });

                self.ignoreWarnings = false;
                self.state.submitting = false;
             
            },

            
            
        },

        computed: {
            addedArticlesExist() {
                return this.addedArticles.articles.length > 0;
            },
            introductionPreview() {
                if (!this.introduction) {
                    return '';
                }
                return this.introduction.replace(/\n/g, '<br />');
            }
        },

        updated() {
            var $ = window.$;
            $(this.$el)
                .find(".selectpicker")
                .selectpicker("refresh");
        },
    }
</script>